'use client';

import type { CSSProperties } from 'react';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import queryString from 'query-string';

import { Container, Select, Stack, Text } from '@/components';
import { useTranslation } from '@/hooks';

const SortBy: React.FC<{
  style?: CSSProperties;
  selectOptions?: { label: string; value: string }[];
  noPagination?: boolean;
}> = ({
  style,
  selectOptions = [
    { label: 'جدیدترین', value: 'newest' },
    { label: 'ارزانترین', value: 'cheapest' },
    { label: 'گرانترین', value: 'most-expensive' },
    { label: 'پرفروش ترین', value: 'best-selling' },
  ],
  noPagination = false,
}) => {
  const { t } = useTranslation('components');
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const sortBy = searchParams.get('sortBy');
  const router = useRouter();
  return (
    <Container>
      <Stack
        gap="3"
        direction="row"
        align="center"
        w="full"
        style={{ ...style }}
      >
        <Text
          fontSize={{ base: 'xs', md: 'md' }}
          minW="max-content"
          fontWeight={500}
        >
          {t('SortBy.sortBy')}
        </Text>
        <Select
          type="sort"
          value={selectOptions.filter((item) => item.value === sortBy)}
          options={selectOptions}
          isCurve
          onChange={(e: { label: string; value: string }) => {
            if (noPagination) {
              router.push(
                `${pathname}?${queryString.stringify({ sortBy: e.value })}`,
                { scroll: false }
              );
            } else {
              router.push(
                `${pathname}?${queryString.stringify({ sortBy: e.value, page: 1 })}`,
                { scroll: false }
              );
            }
          }}
        />
      </Stack>
    </Container>
  );
};
export default SortBy;
